// import React, { useState } from 'react';
// import './AccountStatementModal.css';
// import { CommonModal } from 'components';
// import { StorageServices } from 'utils';
// import { getPaynowStatementDownlaod } from '_services';
// import { useNavigate } from 'react-router-dom';

// const AccountStatementModal = (props) => {
//   const { closeModal, onDownload, accountDetails } = props;
//   const [selectedAccount, setSelectedAccount] = useState(accountDetails?.number);
//   const [selectedPeriod, setSelectedPeriod] = useState('previous-day');
//   const [selectedFormat, setSelectedFormat] = useState('pdf');
//   const firmId = StorageServices.getFirmId();
//   const [isLoading, setIsLoading] = useState(false)
//   const navigate = useNavigate()

//   const formatDate = (date) => {
//     const y = date.getFullYear();
//     const m = String(date.getMonth() + 1).padStart(2, '0');
//     const d = String(date.getDate()).padStart(2, '0');
//     return `${y}-${m}-${d}`;
//   };

//   const getDateRange = () => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     switch (selectedPeriod) {
//       case 'previous-day': {
//         const prevDay = new Date(today);
//         prevDay.setDate(today.getDate() - 1);
//         return { start_date: formatDate(prevDay), end_date: formatDate(prevDay) };
//       }
//       case 'previous-7-days': {
//         const sevenDaysAgo = new Date(today);
//         sevenDaysAgo.setDate(today.getDate() - 7);
//         return { start_date: formatDate(sevenDaysAgo), end_date: formatDate(today) };
//       }
//       case 'current-month': {
//         const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
//         return { start_date: formatDate(firstDay), end_date: formatDate(today) };
//       }
//       case 'last-90-days': {
//         const ninetyDaysAgo = new Date(today);
//         ninetyDaysAgo.setDate(today.getDate() - 90);
//         return { start_date: formatDate(ninetyDaysAgo), end_date: formatDate(today) };
//       }
//       default:
//         return { start_date: '', end_date: '' };
//     }
//   };

//   const handleDownload = async () => {
//     const { start_date, end_date } = getDateRange();
//     const payload = {
//       firm_id: firmId,
//       start_date,
//       end_date,
//       is_web: false,
//     };

//     try {
//       setIsLoading(true)
//       const res = await getPaynowStatementDownlaod(payload);
//       if (!res?.logo) {
//         setIsLoading(false)

//         onDownload()
//       } else {
//         navigate("/accounting/statement_history")
//         setIsLoading(false)
//       }
//     } catch (error) {
//       setIsLoading(false)
//     }
//     closeModal();
//   };

//   const propsModalInhance = {
//     ...props,
//     title: 'Download Account Statement',
//     onSubmit: handleDownload,
//     modalMainClass: 'addbalance',
//     onClose: closeModal,
//     submitTitle: isLoading ? "Downloading..." : " Download Statement",
//   };

//   return (
//     <CommonModal {...propsModalInhance}>
//       <div className="addLr_body">
//         <div className="acst-modal-body">

//           {/* Account Selection */}
//           <div className="acst-form-group">
//             <label className="acst-form-label">SELECTED ACCOUNT</label>
//             <div className="acst-select-wrapper">
//               <input
//                 className="acst-form-select"
//                 value={selectedAccount}
//                 disabled
//               // onChange={(e) => setSelectedAccount(e.target.value)}
//               >
//               </input>
//             </div>
//             <p className="acst-account-name">FRESHTIO SOLUTIONS PRIVATE LIMITED</p>
//           </div>

//           {/* Period Selection */}
//           <div className="acst-form-group">
//             <label className="acst-form-label">SELECT PERIOD</label>
//             <div className="acst-radio-group" style={{ marginBottom: 25 }}>
//               {[
//                 { value: 'previous-day', label: 'Previous day' },
//                 { value: 'previous-7-days', label: 'Previous 7 days' },
//                 { value: 'current-month', label: 'Current month' },
//                 { value: 'last-90-days', label: 'Last 90 days' },
//               ].map(({ value, label }) => (
//                 <label className="acst-radio-label" key={value}>
//                   <input
//                     type="radio"
//                     name="period"
//                     value={value}
//                     checked={selectedPeriod === value}
//                     onChange={(e) => setSelectedPeriod(e.target.value)}
//                   />
//                   <span className="acst-radio-text">{label}</span>
//                 </label>
//               ))}
//             </div>

//             {/* File Format Selection */}
//             <div className="acst-form-group">
//               <label className="acst-form-label">SELECT FILE FORMAT</label>
//               <div className="acst-radio-group acst-radio-inline">
//                 {['pdf'].map((fmt) => (
//                   <label className="acst-radio-label" key={fmt}>
//                     <input
//                       type="radio"
//                       name="format"
//                       value={fmt}
//                       checked={selectedFormat === fmt}
//                       onChange={(e) => setSelectedFormat(e.target.value)}
//                     />
//                     <span className="acst-radio-text">{fmt.toUpperCase()}</span>
//                   </label>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Info Text */}
//           <p className="acst-info-text">
//             You can only download statement for maximum 3 months up to 1 lakh transactions
//           </p>
//         </div>
//       </div>
//     </CommonModal>
//   );
// };

// export default AccountStatementModal;


import React, { useState } from 'react';
import './AccountStatementModal.css';
import { CommonModal, CrossButton } from 'components';
import { StorageServices } from 'utils';
import { getPaynowStatementDownlaod } from '_services';
import { useNavigate } from 'react-router-dom';

const AccountStatementModal = (props) => {
  const { closeModal, onDownload, accountDetails } = props;
  const [selectedAccount, setSelectedAccount] = useState(accountDetails?.number);
  const [selectedPeriod, setSelectedPeriod] = useState('today');
  const [selectedFormat, setSelectedFormat] = useState('pdf');
  const firmId = StorageServices.getFirmId();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const getDateRange = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (selectedPeriod) {
      case 'today':
        return { start_date: formatDate(today), end_date: formatDate(today) };
      case 'yesterday': {
        const prev = new Date(today);
        prev.setDate(today.getDate() - 1);
        return { start_date: formatDate(prev), end_date: formatDate(prev) };
      }
      case 'last-7-days': {
        const d = new Date(today);
        d.setDate(today.getDate() - 7);
        return { start_date: formatDate(d), end_date: formatDate(today) };
      }
      case 'this-month': {
        const first = new Date(today.getFullYear(), today.getMonth(), 1);
        return { start_date: formatDate(first), end_date: formatDate(today) };
      }
      case 'previous-month': {
        const firstPrev = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastPrev = new Date(today.getFullYear(), today.getMonth(), 0);
        return { start_date: formatDate(firstPrev), end_date: formatDate(lastPrev) };
      }
      case 'last-90-days': {
        const d = new Date(today);
        d.setDate(today.getDate() - 90);
        return { start_date: formatDate(d), end_date: formatDate(today) };
      }
      default:
        return { start_date: '', end_date: '' };
    }
  };

  const handleDownload = async () => {
    const { start_date, end_date } = getDateRange();
    const payload = { firm_id: firmId, start_date, end_date, is_web: false };
    try {
      setIsLoading(true);
      const res = await getPaynowStatementDownlaod(payload);
      if (!res?.logo) {
        setIsLoading(false);
        onDownload();
      } else {
        navigate('/accounting/statement_history');
        setIsLoading(false);
      }
    } catch {
      setIsLoading(false);
    }
    closeModal();
  };

  const periods = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last-7-days', label: 'Last 7 Days' },
    { value: 'this-month', label: 'This Month' },
    { value: 'previous-month', label: 'Previous Month' },
    { value: 'last-90-days', label: 'Last 90 Days' },
  ];

  const formats = [
    { value: 'pdf', label: 'PDF' },
    // { value: 'excel', label: 'Excel' },
  ];

  return (
    <div className="qs-overlay" >
      <div className="qs-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="qs-header">
          <h2 className="qs-title">Quick Statement</h2>
          <CrossButton
            type="button"
            className="_switchBtn __animEffect_btn"
            style={{ marginLeft: "auto" }}
            onClick={closeModal}
          >
            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path
                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                fill="black" />
            </svg>
          </CrossButton>
        </div>

        {/* Body */}
        <div className="qs-body">
          {/* Period */}
          <p className="qs-section-label">Select Period</p>
          <div className="qs-period-list">
            {periods.map(({ value, label }) => (
              <label key={value} className={`qs-period-row ${selectedPeriod === value ? 'qs-period-row--active' : ''}`}>
                <span className={`qs-radio-circle ${selectedPeriod === value ? 'qs-radio-circle--checked' : ''}`}>
                  {selectedPeriod === value && <span className="qs-radio-dot" />}
                </span>
                <span className="qs-period-label">{label}</span>
                <input
                  type="radio"
                  name="period"
                  value={value}
                  checked={selectedPeriod === value}
                  onChange={(e) => setSelectedPeriod(e.target.value)}
                  className="qs-hidden-radio"
                />
              </label>
            ))}
          </div>

          {/* Format */}
          <p className="qs-section-label" style={{ marginTop: 20 }}>Document Type</p>
          <div className="qs-format-row">
            {formats.map(({ value, label }) => (
              <label key={value} className="qs-format-option">
                <span className={`qs-radio-circle ${selectedFormat === value ? 'qs-radio-circle--checked' : ''}`}>
                  {selectedFormat === value && <span className="qs-radio-dot" />}
                </span>
                <span className="qs-format-label">{label}</span>
                <input
                  type="radio"
                  name="format"
                  value={value}
                  checked={selectedFormat === value}
                  onChange={(e) => setSelectedFormat(e.target.value)}
                  className="qs-hidden-radio"
                />
              </label>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="qs-footer">
          <button className="qs-download-btn" onClick={handleDownload} disabled={isLoading}>
            {isLoading ? 'Downloading...' : 'Download Report'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountStatementModal;